module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-72x72.png";